<div class="flex flex-col gap-0">
    <span class="text-xs text-shui-text-moderate font-semibold">{{ label() | translate }}</span>
    <span class="text-sm text-shui-text-strong">
        <ng-content></ng-content>
    </span>
</div>
